import { render, staticRenderFns } from "./earningsStatement.vue?vue&type=template&id=2123e486&scoped=true"
import script from "./earningsStatement.vue?vue&type=script&lang=js"
export * from "./earningsStatement.vue?vue&type=script&lang=js"
import style0 from "./earningsStatement.vue?vue&type=style&index=0&id=2123e486&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2123e486",
  null
  
)

export default component.exports